import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Rocket, User, Lock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function DemoLoginPage() {
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [agentName, setAgentName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!agentName.trim() || agentName.trim().length < 3) {
      toast.error("Escribe tu nombre completo");
      return;
    }
    if (!password.trim()) {
      toast.error("Ingresa la contraseña");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/api/demo/login`, {
        password: password.trim(),
        agent_name: agentName.trim(),
      });
      sessionStorage.setItem("holaradar_demo_token", data.demo_token);
      sessionStorage.setItem("holaradar_demo_agent", data.agent_name);
      nav("/demo");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No pude iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-900 via-neutral-950 to-black text-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-block w-16 h-16 rounded-2xl bg-gradient-to-br from-[#FF007A] to-[#0055FF] grid place-items-center mb-4 shadow-2xl">
            <Rocket className="w-8 h-8" />
          </div>
          <h1 className="font-heading font-extrabold text-3xl">Modo Prueba</h1>
          <p className="text-sm text-neutral-400 mt-1">Acceso exclusivo asesores comerciales HOLA RADAR</p>
        </div>

        <form onSubmit={submit} className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-6 space-y-4">
          <div>
            <Label className="text-xs text-neutral-300 flex items-center gap-2"><User className="w-3 h-3" /> Nombre completo del asesor</Label>
            <Input
              value={agentName}
              onChange={(e) => setAgentName(e.target.value)}
              placeholder="Ej: Juan Pérez"
              className="mt-1 h-11 rounded-xl bg-white/10 border-white/20 text-white placeholder:text-neutral-500"
              data-testid="demo-agent-name-input"
              maxLength={80}
              autoFocus
            />
          </div>
          <div>
            <Label className="text-xs text-neutral-300 flex items-center gap-2"><Lock className="w-3 h-3" /> Contraseña</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="•••"
              className="mt-1 h-11 rounded-xl bg-white/10 border-white/20 text-white"
              data-testid="demo-password-input"
              maxLength={20}
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-full bg-[#FF007A] hover:bg-[#e60070] font-bold"
            data-testid="demo-login-submit"
          >
            {loading ? "Entrando…" : <>Entrar al modo prueba <ArrowRight className="w-4 h-4" /></>}
          </Button>
        </form>

        <p className="text-center text-xs text-neutral-500 mt-6">
          Si eres un cliente y llegaste aquí por error, regresa a la <a href="/" className="text-[#FF007A] hover:underline">página principal</a>.
        </p>
      </div>
    </div>
  );
}
